import { useState } from 'react';
import { useAppSelector } from './redux';

export const useOnboarding = () => {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [isCompleting, setIsCompleting] = useState(false);
  const { user } = useAppSelector(state => state.auth);

  const needsOnboarding = user?.role === 'customer' && (!user?.customerId || user?.customerId === null);

  const startOnboarding = () => {
    setShowOnboarding(true);
  };

  const skipOnboarding = () => {
    setShowOnboarding(false);
  };

  const handleCompleteOnboarding = (data: any) => {
    // The API mutation already updated Redux state, just close onboarding
    setShowOnboarding(false);
    setIsCompleting(false);
  };

  return {
    needsOnboarding,
    showOnboarding,
    isCompleting,
    startOnboarding,
    skipOnboarding,
    completeOnboarding: handleCompleteOnboarding,
  };
};